/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CreateTaskAction from './CreateTaskAction/index'
import EditLetterAction from './EditLetterAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import ViewTaskAction from './ViewTaskAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Actions"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let letterTaskIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'task_id',
})
let letterTaskIdValueData1 = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'task_id',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-AjnkD': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={!letterTaskIdValueData}>
<CreateTaskAction
  viewPath={`${viewPath}/CreateTaskAction`}
 data="letter.task_id"
/>
</fromFlow.When>
<fromFlow.When is={letterTaskIdValueData1}>
<ViewTaskAction
  viewPath={`${viewPath}/ViewTaskAction`}
 data="letter.task_id"
/>
</fromFlow.When>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="|"
 color={dtColorsNeutral300}
/>
<EditLetterAction
  viewPath={`${viewPath}/EditLetterAction`}
/>
</div>
{children}
</React.Fragment>)
}